import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconArrowUpOutlineStyle0 = gravityIconIndividualCss;

const GravityIconArrowUpOutline = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '3675e853aff4478605c4c501184af3dc1f11d261', color: this.color, size: this.size }, h("svg", { key: 'c7a89978eaef40a2d314343f966b7ae5c3ad9738', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '3ee6b72728747a1180d728ff56091b69188d16a4', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m10.65 6.29-5.82 5.83a.48.48 0 0 0 0 .7l.35.36a.51.51 0 0 0 .71 0L11 8.06l5.11 5.12a.51.51 0 0 0 .71 0l.35-.36a.48.48 0 0 0 0-.7l-5.81-5.83a.51.51 0 0 0-.71 0Z", fill: "currentColor" }))));
    }
};
GravityIconArrowUpOutline.style = GravityIconArrowUpOutlineStyle0;

export { GravityIconArrowUpOutline as gravity_icon_arrow_up_outline };

//# sourceMappingURL=gravity-icon-arrow-up-outline.entry.js.map